<template>
	<div v-cloak>
		<button class="btn btn-primary" :class="styling" ref="btnContentBaseLogin" :data-bs-toggle="dataToggle" :data-bs-target="dataTarget">
			<img :src="emailLoginIcon" data-graphic-source="/img/login-buttons/contentbase/icon-contentbase.png" />
			<span>Sign in with Email</span>
		</button>
	</div>
</template>




<script>
	import emailLoginIcon from '@/img/login-buttons/contentbase/icon-contentbase.optimized.webp';
	import { mixinAxios } from '@/js/shared/VueMixins.js';
	import { parseWidthValue } from '@/js/shared/utils/common';
	export default {
		mixins: [mixinAxios],
		data: () => ({
			emailLoginIcon,
		}),
		props: {
			styling    : { type: String, default: 'styling0' },
			dataToggle : { type: String, default: 'modal' },
			dataTarget : { type: String, default: '#modal-container-sign-in-form' },
			width      : { type: [String, Number], default: 300 },
		},
		mounted() {
			this.setWidth();
		},
		methods: {
			setWidth() {
				this.btnContentBaseLogin.style.width = parseWidthValue(this.width);
			}
		},
		computed: {
			btnContentBaseLogin() {
				return this.$refs['btnContentBaseLogin'];
			}
		},
		watch: {
			width(newVal, oldVal) {
				this.setWidth();
			}
		}
	};
</script>




<style scoped>
	[v-cloak] {
		display: none;
	}


	/* common */

	/* common */


	/* styling 0 */

	.styling0 {
		font-family: 'Roboto', sans-serif;
		font-weight: normal;
		font-size: 16px;
		height: 40px;
		padding: 0px 12px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 4px;
		cursor: pointer;
	}

	.styling0 img {
		display: none;
		height: 22px;
		width: 22px;
	}

	.styling0 span {
		margin: 3px 0px 0px 0px;
	}

	/* styling 0 */


	/* styling 1 */

	.styling1 {
		font-family: 'Roboto', sans-serif;
		font-weight: normal;
		font-size: 16px;
		height: 44px;
		padding: 0px 12px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 4px;
		cursor: pointer;
	}

	.styling1 img {
		height: 22px;
		width: 22px;
	}

	.styling1 span {
		margin: 3px 0px 0px 10px;
	}

	/* styling 1 */

</style>
